import React, { FC } from 'react'
import cx from 'clsx';

import { StyledPictureList, StyledPictureListItem } from './picture-list.styles';

export type PictureListProps = {
  className?: string;
  list: Array<{ webP?: string, jpg: string }>;
  activeItem: number;
}

export const PictureList: FC<PictureListProps> = ({
  className,
  list,
  activeItem,
}) => {
  const classes = cx('PictureList', { [className as string]: !!className });

  return (
    <StyledPictureList className={classes}>
      {
        !!list.length && list.map((item, index) => (
          <StyledPictureListItem className={ cx({ active: index === activeItem })} key={item.jpg}>
            { item?.webP && <source srcSet={item.webP} type="image/webp" /> }
            <img src={item.jpg} alt="" />
          </StyledPictureListItem>
        ))
      }
    </StyledPictureList>
  )
}
